module.exports = __webpack_public_path__ + "img/6.2f1c6b1b.png";